// extracted by mini-css-extract-plugin
export var container = "footer-module--container--c231e";
export var hr = "footer-module--hr--d6544";
export var logo = "footer-module--logo--e67c9";
export var nav = "footer-module--nav--d4c8a";
export var root = "footer-module--root--845ec";
export var social = "footer-module--social--01762";
export var top = "footer-module--top--af58d";